import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { BetslipError } from '../betslip-error';
import { NotifyUserErrorMixin } from '../notify-user-error';
import { ResultError } from './result-error';

export class PickInvisible extends NotifyUserErrorMixin<ResultError, typeof ResultError>(ResultError) {
    constructor(pickId: string) {
        super(pickId);
        this.icon = BetPlacementErrorIcon.Warning;
        this.priority = -999;
        this.hasClientValidation = true;
        this.type = PlacementErrorType.OptionInvisible;
    }

    override equals(error: BetslipError): boolean {
        return error instanceof PickInvisible && error.pickId === this.pickId;
    }
}
